import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type InfoLetters = boolean;
type SystemNotification = boolean;

// ----------------------- actions -------------------------------------
const SET_SETTINGS_INFO_LETTERS = 'SET_SETTINGS_INFO_LETTERS';
const SET_SETTINGS_SYSTEM_NOTIFICATIONS = 'SET_SETTINGS_SYSTEM_NOTIFICATIONS';

interface PayloadTypes {
    [SET_SETTINGS_INFO_LETTERS]: InfoLetters;
    [SET_SETTINGS_SYSTEM_NOTIFICATIONS]: SystemNotification;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setInfoLetters = ActionCreator(SET_SETTINGS_INFO_LETTERS);
export const setSystemNotifications = ActionCreator(SET_SETTINGS_SYSTEM_NOTIFICATIONS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface SettingsState {
    infoLetters: InfoLetters;
    systemNotifications: SystemNotification;
}

export const SETTINGS_INITIAL_STATE: SettingsState = {
    infoLetters: false,
    systemNotifications: false,
};

export default createReducer<SettingsState, PayloadTypes>(SETTINGS_INITIAL_STATE, {
    [SET_SETTINGS_INFO_LETTERS]: (state, { payload }) => ({
        ...state,
        infoLetters: payload,
    }),
    [SET_SETTINGS_SYSTEM_NOTIFICATIONS]: (state, { payload }) => ({
        ...state,
        systemNotifications: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
